<div class="card cashplus-widget">
  <div class="widget-title-and-balance">
    <div class="widget-status">
      <div class="widget-status-title">{{ "cash_plus" | translate }}</div>
      <bp-pill-info>{{ "cash_plus_auto_roll_on_tag" | translate }}</bp-pill-info>
    </div>
    <div class="widget-balance"
      >{{ "cash_plus_balance" | translate }}
      {{
      +cashPlusPortfolio?.parked_asset_balance
      | fiat_precision_symbol
      : {
      id: currencyId,
      symbol: false
    }
    }}
  </div>
</div>

<div class="rewards-description">
  <div class="rewards-description-details">
    <div class="rewards-description-details-title">{{ "cash_plus_total_rewards" | translate }}</div>
    <div class="rewards-description-details-amount">{{
      +cashPlusPortfolio?.total_rewards
      | fiat_precision_symbol
      : {
      id: currencyId,
      symbol: true
    }
  }}</div>
</div>
<div class="rewards-description-details">
  <div class="rewards-description-details-title">{{ "cash_plus_payout_frequency" | translate }}</div>
  @if (cashPlusConfig?.payout_frequency === 'monthly') {
    <div class="rewards-description-details-amount">{{
      "fiat_wallet_cash_plus_monthly_frequency" | translate
    }}</div>
  }
</div>
<div class="rewards-description-details">
  <div class="rewards-description-details-title">{{ "cash_plus_last_payout" | translate }}</div>
  <div class="rewards-description-details-amount">{{
    +cashPlusPortfolio?.last_reward
    | fiat_precision_symbol
    : {
    id: currencyId,
    symbol: true
  }
}}</div>
</div>
<div class="rewards-description-details">
  <div class="rewards-description-details-title-info">
    <div class="rewards-description-details-title">{{ "cash_plus_current_rate" | translate }}</div>
    <bp-icon
      class="rewards-description-details-info"
      icon="info"
      size="24"
      theme="regular"
    (click)="onInfoClick('current_rate')"></bp-icon>
  </div>
  <div class="rewards-description-details-amount">{{ currentRate | percent_symbol }}</div>
</div>
</div>
<div class="widget-buttons">
  <div class="widget-toggle">
    <div class="widget-toggle-title">{{ "cash_plus_off_toggle" | translate }}</div>

    <div class="toggle-container">
      <div class="toggle" (click)="onToggleClick($event)"></div>
      <toggle-input-ui [(ngModel)]="defaultToggle" [disabled]="true"></toggle-input-ui>
    </div>
  </div>
  <button
    class="btn btn-primary btn-inverse move-balance-button"
    [disabled]="+cashPlusPortfolio?.parked_asset_balance === 0"
    (click)="onCashOutClick()"
    >{{ "cash_plus_move_balance" | translate }}</button
    >
  </div>
</div>
